import React from 'react';

import css from './SectionMentorInfo.module.css';
import HeaderBar from '../HeaderBar/HeaderBar';
import { getHasProfileListing } from '../../../../util/userUtil';
import { NamedLink } from '../../../../components';

const SectionMentorInfo = props => {
  const { currentUser } = props;

  const hasProfileListing = getHasProfileListing(currentUser);

  return (
    <div className={css.root}>
      <HeaderBar currentUser={currentUser} />

      {!hasProfileListing && (
        <div className="card gap20 mt20">
          <h3>Welcome to Sonispark!</h3>

          <p>
            Our students have been waiting for you. Fill your profile info with a few quick steps
            and get booked in mentoring sessions.
          </p>

          <NamedLink className={css.addProfile} name="NewListingPage">
            Create Profile Now
          </NamedLink>
        </div>
      )}
    </div>
  );
};

export default SectionMentorInfo;
